import React, { FC } from 'react'
import { Box, Flex, LinkOverlay, Text } from 'front-end/src/components'
import { linkBuilder } from 'shared/linkBuilder'
import IconLayers from 'front-end/src/components/common/icon/IconLayers'
import IconLock from 'front-end/src/components/common/icon/IconLock'

export const NavigationWorkspaceItem: FC<{
  workspace: any
  hideNavigation: () => void
}> = ({ children, workspace, hideNavigation }) => {
  return (
    <Flex className="Navigation__link__wrapper">
      <LinkOverlay
        className="Navigation__link"
        to={linkBuilder.workspaceUrl(workspace.id)}
        onClick={hideNavigation}
        title={workspace.name}
      >
        <Flex align="center" position="relative">
          <IconLayers />
          {!workspace.is_open && <IconLock />}
        </Flex>

        <Text flex={1} noOfLines={2}>
          {workspace.name}
        </Text>
        {(workspace.assignedEnrolmentsCount as number) > 0 && (
          <Box as="span" className="Navigation__link__assignmentCount">
            {workspace.assignedEnrolmentsCount}
          </Box>
        )}
      </LinkOverlay>
      {children}
    </Flex>
  )
}
